module.exports = __webpack_public_path__ + "static/media/whatsapp-clone.4c54ee98.webp";